"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function mth(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M5.25 7.1759L8.4255 12.5032V17.9999C6.672 17.9999 5.25 16.6229 5.25 14.9242V7.1759Z", fill: color, fillOpacity: 0.5 }),
        React.createElement("path", { d: "M15.5737 12.4972L18.7477 7.17297H18.7492V14.925C18.7499 16.623 17.3279 18 15.5737 18V12.4972Z", fill: color, fillOpacity: 0.6 }),
        React.createElement("path", { d: "M11.9977 12.3429L10.41 15.0069C10.0807 14.9244 9.72675 14.6049 9.348 14.0492L5.25 7.17542C6.76875 6.32567 8.71125 6.83042 9.588 8.30042L11.9977 12.3429Z", fill: color, fillOpacity: 0.8 }),
        React.createElement("path", { d: "M14.412 8.29496C15.2888 6.82346 17.2313 6.31946 18.75 7.16921L14.652 14.043C14.356 14.472 13.9597 14.8223 13.4975 15.0633C13.0354 15.3044 12.5213 15.4288 12 15.426C11.5064 15.4269 11.0191 15.3153 10.575 15.0997L10.41 15.0075L14.412 8.29496Z", fill: color }),
        React.createElement("path", { d: "M5.25 6.79773L8.4255 12.125V17.6217C6.672 17.6217 5.25 16.2447 5.25 14.546V6.79773Z", fill: color, fillOpacity: 0.5 }),
        React.createElement("path", { d: "M15.5737 12.119L18.7477 6.7948H18.7492V14.5468C18.7499 16.2448 17.3279 17.6218 15.5737 17.6218V12.119Z", fill: color, fillOpacity: 0.6 }),
        React.createElement("path", { d: "M11.9977 11.9647L10.41 14.6287C10.0807 14.5462 9.72675 14.2267 9.348 13.671L5.25 6.79725C6.76875 5.9475 8.71125 6.45225 9.588 7.92225L11.9977 11.9647Z", fill: color, fillOpacity: 0.8 }),
        React.createElement("path", { d: "M14.412 7.91679C15.2888 6.44529 17.2313 5.94129 18.75 6.79104L14.652 13.6648C14.356 14.0939 13.9597 14.4441 13.4975 14.6852C13.0354 14.9262 12.5213 15.0507 12 15.0478C11.5064 15.0488 11.0191 14.9372 10.575 14.7215L10.41 14.6293L14.412 7.91679Z", fill: color }));
}
exports["default"] = mth;
//# sourceMappingURL=mth.js.map